module.exports = __webpack_public_path__ + "static/media/custom-icon--white.712aec8d.svg";